import { FC, useEffect, useState } from 'react'
import cn from 'classnames'
import { useCart } from '@corratech/pylot-cart-manager'
import { Heart, Bag, Currency, User, RewardsIcon } from '@components/icons'
import { useUI } from '@corratech/pylot-ui/context'
import { useAuthUI, useAccount } from '@corratech/pylot-auth-manager'
import { Button } from '@corratech/pylot-ui'
import DropdownMenu from './DropdownMenu'
import { LanguageDropdown } from '@corratech/pylot-locale-pickers'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import { useCartItemsCount } from '@components/alfakher/pylot-cart-manager/src/hooks/use-cart-items-count'
import { useAlfakherContext } from '@components/alfakherContext/AlfakherContext'
import s from './UserNav.module.scss'

interface Props {
    className?: string
    showCurrency: boolean
}

const UserNav: FC<Props> = ({ className, showCurrency = true }) => {
    const { t } = useTranslation()
    const { data: cartData } = useCart()
    const { data } = useAccount()
    const [display, setDisplay] = useState(false)
    const { toggleSidebar } = useUI()
    const { openAuthModal, onLoginCallback, onSignUpCallback } = useAuthUI()
    const {
        setToggleReinitYotpoReviewPageWidget,
        toggleYotpoReviewPageWidget
    } = useAlfakherContext()

    const customer = data?.data?.customer
    const router = useRouter()

    const cartItemsCount = useCartItemsCount(cartData?.data?.cart?.items)

    const handleRedirect = (url: string) => {
        const redirectFunction = () => router.push(url)
        if (!customer) {
            openAuthModal()
            onLoginCallback([() => redirectFunction()])
            onSignUpCallback([() => redirectFunction()])
        } else {
            redirectFunction()
        }
    }

    useEffect(() => {
        setToggleReinitYotpoReviewPageWidget(!toggleYotpoReviewPageWidget)
    }, [data?.data?.customer?.firstname])

    const isTokenExist =
        typeof window !== 'undefined' &&
        window.localStorage.getItem('pylot_token')
    return (
        <nav className={cn(s.root, className)}>
            <ul className={s.list}>
                {showCurrency && (
                    <li className={cn(s['currency-menu'], s.item)}>
                        <Button
                            variant="link"
                            onClick={() => setDisplay(!display)}
                        >
                            <Currency />
                        </Button>
                        {display ? <LanguageDropdown /> : ''}
                    </li>
                )}
                <li className={cn(s['user-menu'], s.item)}>
                    {isTokenExist ? (
                        <DropdownMenu />
                    ) : (
                        <Button
                            className={s.avatarButton}
                            variant="link"
                            onClick={() => openAuthModal()}
                            aria-label={t('Menu')}
                        >
                            <User />
                        </Button>
                    )}
                </li>
                <li className={cn(s['user-menu'], s.item)}>
                    <Button
                        className={cn(s['rewards-icon'], s.avatarButton)}
                        variant="link"
                        onClick={() => handleRedirect('/account/rewards')}
                        aria-label={t('Rewards & Referrals')}
                    >
                        <RewardsIcon />
                    </Button>
                </li>
                <li className={cn(s['item'], s['wishlist-icon'])}>
                    <Button
                        variant="link"
                        onClick={() => handleRedirect('/account/wishlist')}
                        aria-label={t('Wishlist')}
                    >
                        <Heart />
                    </Button>
                </li>
                <li className={s.item}>
                    <Button
                        className={cn(s['bag-btn'])}
                        variant="link"
                        onClick={toggleSidebar}
                        aria-label={t('Bag')}
                    >
                        <Bag />
                        {cartItemsCount && cartItemsCount > 0 ? (
                            <span className={s['cart-count']}>
                                {cartItemsCount}
                            </span>
                        ) : (
                            ''
                        )}
                    </Button>
                </li>
            </ul>
        </nav>
    )
}

export default UserNav
